import React from 'react';
import './StickyDateIndicator.scss';

interface StickyDateIndicatorProps {
    date: string;
    visible: boolean;
}

const StickyDateIndicator: React.FC<StickyDateIndicatorProps> = ({ date, visible }) => {
    if (!visible || !date) return null;

    return (
        <div className="sticky-date-indicator">
            {/* <div className="date-separator-line"></div> */}
            <div className="date-separator-text">{date}</div>
            {/* <div className="date-separator-line"></div> */}
        </div>
    );
};

export default StickyDateIndicator;
